import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { getClassNames } from '../../styles/theme';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const classNames = getClassNames(theme);

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-lg ${theme === 'dark' ? 'bg-primary-700 hover:bg-primary-600' : 'bg-gray-100 hover:bg-gray-200'} transition-colors`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
        <Moon className="w-5 h-5 text-accent-wood" />
      ) : (
        <Sun className="w-5 h-5 text-accent-wood" />
      )}
    </button>
  );
};

export default ThemeToggle; 